import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 报警信息列表接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	warningList( params={} ) {
		return request({
	    url: baseUrl + '/device/alarms',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 报警信息更新接口
	**/
	warningUpdate(id){
		return request({
			url: baseUrl + '/device/alarms/'+id,
			method:'PUT'
		})
	},

	/**
	 * 策略删除
	**/
	warningDel(id){
		return request({
			url: baseUrl + '/device/alarms/'+id,
			method:'DELETE'
		})
	},
}